"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _plus = _interopRequireDefault(require("cccisd-icons/plus2"));
var _admin = require("../../../../reducers/admin");
var _helpers = require("../../helpers");
var _FormSession = _interopRequireDefault(require("../FormSession"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var initialValues = {
  datePicker: false,
  sessions: []
};
var sessionInitialValues = {
  surveys: []
};
function SessionDataConfig(_ref) {
  var assignmentData = _ref.assignmentData,
    navigationSettings = _ref.navigationSettings,
    selectedSessionType = _ref.selectedSessionType,
    deploymentList = _ref.deploymentList,
    closeModal = _ref.closeModal;
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    sessions = _useState2[0],
    setSessions = _useState2[1];
  var existingConfig = _objectSpread(_objectSpread({}, initialValues), {}, {
    sessionType: selectedSessionType
  }, navigationSettings);
  (0, _react.useEffect)(function () {
    if (navigationSettings.sessions === undefined) {
      setSessions([]);
    } else {
      setSessions(navigationSettings.sessions);
    }
  }, []);
  function onSubmit(_x) {
    return _onSubmit.apply(this, arguments);
  }
  function _onSubmit() {
    _onSubmit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(values) {
      var createHandle, createHash, batchToCreate, batchToUpdate, batchToRemove, _t;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            createHash = function _createHash() {
              return Math.random().toString(36).substring(2, 9);
            };
            createHandle = function _createHandle(label, hash) {
              return "".concat(label.toLowerCase().trim().replace(' ', '_'), "_").concat(hash);
            };
            values.sessions = values.sessions.map(function (session) {
              if (session.hash) {
                return _objectSpread({}, session);
              }
              var hash = createHash();
              return _objectSpread(_objectSpread({}, session), {}, {
                hash: hash,
                handle: createHandle(session.label, hash)
              });
            });
            if ((0, _isEqual2["default"])(existingConfig, values)) {
              _context4.n = 4;
              break;
            }
            // identify which sessions are new
            batchToCreate = values.sessions.filter(function (session) {
              return !existingConfig.sessions.map(function (s) {
                return s.hash;
              }).includes(session.hash);
            }); // identify which sessions need to be updated
            batchToUpdate = values.sessions.filter(function (session) {
              return existingConfig.sessions.map(function (s) {
                return s.hash;
              }).includes(session.hash);
            }).filter(function (session) {
              return !(0, _isEqual2["default"])(session, existingConfig.sessions.find(function (s) {
                return s.hash === session.hash;
              }));
            }); // identify which sessions need to be removed
            batchToRemove = existingConfig.sessions.filter(function (session) {
              return !values.sessions.map(function (s) {
                return s.hash;
              }).includes(session.hash);
            });
            batchToCreate.forEach(/*#__PURE__*/function () {
              var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref4) {
                var hash, handle, label, surveys, isCreateSuccess;
                return _regenerator().w(function (_context) {
                  while (1) switch (_context.n) {
                    case 0:
                      hash = _ref4.hash, handle = _ref4.handle, label = _ref4.label, surveys = _ref4.surveys;
                      _context.n = 1;
                      return dispatch((0, _admin.createWave)(assignmentData.assignmentId, {
                        type: 'group',
                        roleHandle: 'metricspawn',
                        hash: hash,
                        label: label,
                        handle: handle,
                        isOpen: true,
                        settings: {
                          options: Object.keys(surveys),
                          allowRetake: true
                        }
                      }));
                    case 1:
                      isCreateSuccess = _context.v;
                      if (!isCreateSuccess) {
                        (0, _cccisdNotification["default"])({
                          type: 'danger',
                          message: "Quest failed to update"
                        });
                      }
                    case 2:
                      return _context.a(2);
                  }
                }, _callee);
              }));
              return function (_x2) {
                return _ref5.apply(this, arguments);
              };
            }());
            batchToUpdate.forEach(/*#__PURE__*/function () {
              var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref6) {
                var hash, handle, label, surveys, _deploymentList$find, deploymentId, settings, isUpdateSuccess;
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      hash = _ref6.hash, handle = _ref6.handle, label = _ref6.label, surveys = _ref6.surveys;
                      _deploymentList$find = deploymentList.find(function (deployment) {
                        return hash === deployment.hash;
                      }), deploymentId = _deploymentList$find.deploymentId, settings = _deploymentList$find.settings;
                      _context2.n = 1;
                      return dispatch((0, _admin.updateWave)(deploymentId, {
                        label: label,
                        handle: handle,
                        settings: _objectSpread(_objectSpread({}, settings), {}, {
                          options: Object.keys(surveys)
                        })
                      }));
                    case 1:
                      isUpdateSuccess = _context2.v;
                      if (!isUpdateSuccess) {
                        (0, _cccisdNotification["default"])({
                          type: 'danger',
                          message: "Quest failed to update"
                        });
                      }
                    case 2:
                      return _context2.a(2);
                  }
                }, _callee2);
              }));
              return function (_x3) {
                return _ref7.apply(this, arguments);
              };
            }());
            batchToRemove.forEach(/*#__PURE__*/function () {
              var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(_ref8) {
                var hash, _deploymentList$find2, deploymentId;
                return _regenerator().w(function (_context3) {
                  while (1) switch (_context3.n) {
                    case 0:
                      hash = _ref8.hash;
                      _deploymentList$find2 = deploymentList.find(function (deployment) {
                        return hash === deployment.hash;
                      }), deploymentId = _deploymentList$find2.deploymentId;
                      _context3.n = 1;
                      return dispatch((0, _admin.removeWave)(deploymentId));
                    case 1:
                      return _context3.a(2);
                  }
                }, _callee3);
              }));
              return function (_x4) {
                return _ref9.apply(this, arguments);
              };
            }());
            _context4.p = 1;
            _context4.n = 2;
            return dispatch((0, _admin.updateQuest)(assignmentData.assignmentId, _objectSpread(_objectSpread({
              title: 'Session Data Entry',
              subtitle: 'Quest for Session Data Entry Page Configuration',
              handle: "session_data_".concat(assignmentData.assignmentId)
            }, assignmentData.settings), {}, {
              navigationSettings: _objectSpread(_objectSpread({}, existingConfig), values)
            })));
          case 2:
            (0, _cccisdNotification["default"])("Quest successfully updated");
            closeModal();
            _context4.n = 4;
            break;
          case 3:
            _context4.p = 3;
            _t = _context4.v;
            (0, _cccisdNotification["default"])({
              type: 'danger',
              message: "Quest failed to update"
            });
          case 4:
            return _context4.a(2);
        }
      }, _callee4, null, [[1, 3]]);
    }));
    return _onSubmit.apply(this, arguments);
  }
  function _onDragEnd(result, swap) {
    if (!result.destination || result.destination.index === result.source.index) {
      return;
    }
    swap(result.destination.index, result.source.index);
  }
  return sessions && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
    onSubmit: onSubmit,
    initialValues: _objectSpread({}, existingConfig)
  }, function (_ref2) {
    var values = _ref2.values,
      isSubmitting = _ref2.isSubmitting,
      submitForm = _ref2.submitForm;
    return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "datePicker",
      component: _cccisdFormik.CccisdToggle,
      label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
        label: "Use Session Date Picker",
        tooltip: "The Session Date Picker is used to assign a date to each session. Date picker will allow for indication of whether the session was held or missed on the date selected."
      })
    }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.FieldArray, {
      name: "sessions"
    }, function (_ref3) {
      var push = _ref3.push,
        remove = _ref3.remove,
        swap = _ref3.swap;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.DragDropContext, {
        onDragEnd: function onDragEnd(result) {
          return _onDragEnd(result, swap);
        }
      }, /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Droppable, {
        droppableId: "droppable"
      }, function (provided, snapshot) {
        return /*#__PURE__*/_react["default"].createElement("div", _extends({}, provided.droppableProps, {
          ref: provided.innerRef
        }), values.sessions.map(function (value, i) {
          return /*#__PURE__*/_react["default"].createElement(_FormSession["default"], {
            value: value,
            key: i,
            surveyList: assignmentData.currentSurveylistList.surveyList,
            sessions: navigationSettings.sessions,
            sessionNumber: i + 1,
            removeSession: function removeSession() {
              return remove(i);
            }
          });
        }), provided.placeholder);
      })), /*#__PURE__*/_react["default"].createElement("button", {
        className: _style["default"].addSessionButton
        // style={{ marginTop: '1em' }}
        ,
        type: "button",
        onClick: function onClick() {
          return push(sessionInitialValues);
        }
      }, /*#__PURE__*/_react["default"].createElement(_plus["default"], {
        spaceRight: true
      }), "Add Session"));
    }), /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'flex-end'
      }
    }, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
      className: "btn btn-primary",
      isLoading: isSubmitting,
      isDisabled: isSubmitting || (0, _isEqual2["default"])(existingConfig, values),
      onClick: function onClick() {
        return submitForm();
      }
    })));
  });
}
var _default = exports["default"] = SessionDataConfig;